import EditScenePreview from './EditScenePreview';

export default EditScenePreview;
